import * as React from 'react';

import { PolicyEditorView } from './policy-editor.view';
import { PolicyListDataService } from '../list/policy-list.data';

interface Props {
	value?: number;
	label?: string;
	required?: boolean;
	mode: ControlMode;
	onChange: (value?: PolicySummary) => void;
	setBusy(isBusy: boolean);
	onGetErrorMessage?: () => Promise<ValidationError[]>
}

export class PolicyEditorController extends React.Component<Props, {}> {
	private dataService: PolicyListDataService;

	constructor(props: Readonly<Props>) {
		super(props);

		this.dataService = PolicyListDataService.make();
	}

	query = async (keywords?: string): Promise<QueryResult<PolicySummary>> => {
		this.dataService.searchKeywords = keywords;
		this.dataService.addFilter('isDeleted', 'eq', false);
		this.dataService.addSorting('id', 'asc');

		const items = await this.dataService.load((qry) => qry);

		return {
			items: items,
			totalCount: items.length,
		};
	};

	render() {
		return (
			<PolicyEditorView
				request={{ query: this.query, dataSet: this.dataService }}
				{ ...this.props }
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/policies/parts/policy-editor.controller.tsx